module.exports = __webpack_public_path__ + "src/assets/img/-1.0681d34e.svg";